import React, { type FC } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Text, Stack, xcss } from '@atlaskit/primitives';

import { LazyEmojiComponentLoader } from '@confluence/emoji-title';
import { LegacyContentIcon } from '@confluence/icons/entry-points/LegacyContentIcon';

type ContentTitleProps = {
	emojiId?: string;
	title?: string;
	subTitle?: string;
	isLink?: boolean;
};

const EmojiStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	overflow: 'hidden',
	width: '24px',
	height: '24px',
});

export const ContentTitle: FC<ContentTitleProps> = ({ emojiId, title, subTitle, isLink }) => {
	const titleComponent = (
		<Text color={isLink ? 'color.link' : 'color.text'} maxLines={1}>
			{title}
		</Text>
	);
	const subTitleComponent = (
		<Text size="small" maxLines={1}>
			{subTitle}
		</Text>
	);

	return (
		<>
			{emojiId ? (
				<LazyEmojiComponentLoader
					emoji={emojiId}
					height={24}
					context="pageCard"
					wrapper={({ children }: { children?: React.ReactNode }) => (
						<Box xcss={EmojiStyles}>{children}</Box>
					)}
				/>
			) : (
				<LegacyContentIcon size="medium" label="" />
			)}
			{subTitle ? (
				<Stack>
					{titleComponent}
					{subTitleComponent}
				</Stack>
			) : (
				titleComponent
			)}
		</>
	);
};
